import * as R from "ramda";

export const filterNilOrEmpty = R.filter(
  val => !(R.isNil(val) || R.isEmpty(val))
);
